import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../api.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'lib-change-password-code',
  templateUrl: './change-password-code.component.html',
  styleUrls: ['./change-password-code.component.scss']
})
export class ChangePasswordCodeComponent implements OnInit {
  passwordForm: FormGroup;
  submitted: boolean = false;
  confirmPassword: boolean = false;
  @Input() activationKey;
  @Input() link;
  @Output() dataEvent = new EventEmitter();
  constructor(private formbuilder: FormBuilder,private apiService: ApiService) { }

  ngOnInit() {
    this.passwordForm = this.formbuilder.group({
      activationCode: [this.activationKey, Validators.required],
      newPassword: ['',  Validators.compose([
        Validators.required,
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$#!%*?&])[A-Za-z\d@$#!%*?&]{8,}$/)
      ])],
      confirmPassword: ['', Validators.required]
    })
    this.passwordForm.get('activationCode').disable()
  }
  get f() {
    return this.passwordForm.controls;
  }
  encryptUsingAES256(data:any) {
    let _key = CryptoJS.enc.Utf8.parse(this.apiService.tokenKey);
    let _iv = CryptoJS.enc.Utf8.parse(this.apiService.tokenKey);
    let encrypted = CryptoJS.AES.encrypt(
      data, _key, {
        keySize: 128 / 8,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString();
  }
  passwordFun(){
    this.submitted = true;
    console.log(this.passwordForm.value)
    if (this.passwordForm.invalid){
      return;
    }
    
   
     if(this.passwordForm.value.newPassword != this.passwordForm.value.confirmPassword) {
      this.confirmPassword = true; 
      return;
     } else {
      this.confirmPassword = false
     }
     this.passwordForm.get('activationCode').enable();
     
     var data = this.passwordForm.value;
     var oldData = this.passwordForm.value;

     data.newPassword = this.encryptUsingAES256(data.newPassword),
     data.confirmPassword = this.encryptUsingAES256(data.confirmPassword),
     this.apiService.changePasswordByActivationCode(data).subscribe({
      next: data => {
        this.passwordForm.get('activationCode').disable();
        if(data){
          this.passwordForm.reset();
          this.submitted=false;
          this.dataEvent.emit({event:'success'})
        } else {
          this.passwordForm.reset();
          this.passwordForm.patchValue({
            activationCode: oldData.activationCode, 
          });
          this.submitted=false;
          this.dataEvent.emit({event:'failure'})
        }
      },
      error: err => {
        this.passwordForm.get('activationCode').disable();
        if(err.error.message != ''){
          this.passwordForm.reset();
          this.passwordForm.patchValue({
            activationCode: oldData.activationCode, 
          });
          this.submitted=false;
          this.dataEvent.emit({event:'error',message:err.error.error_code})
        }
        console.log('Error', err);
      }
    })
  }
}
